import { TLD_GLOBALLY } from '../../../../constants/constants';
import { topDestination, TOP_DESTINATIONS } from './TopDestinationsData';

const getCurrentTld = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    return `.${parts[parts.length - 1]}`;
};

export const useTopDestinations = (): topDestination[] => {
    const tld = getCurrentTld();
    return TOP_DESTINATIONS[tld] || TOP_DESTINATIONS[TLD_GLOBALLY];
};
